export default "__VITE_ASSET__Bg$OJ0pH__"